import TimeSessionForm from "../components/timeSessionForm";
export const TimeSessionCreation = () => {
  return (
    <>
      <h1>Create a New Time Session</h1>
      <div className="page">
        <TimeSessionForm />
      </div>
    </>
  );
};

export default TimeSessionCreation;
